import type { PartTypeListQuery } from '@chukua/common';
import { Tag, type TableColumnsType } from 'antd';
import { Link } from 'react-router';
import { CatalogueRowActions } from '../../../../../shared/components/CatalogueRowActions';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import { partTypePath } from '../part-types.paths';
import type { PartTypeView } from '../part-types.api';
import { formatExpectedLifeDays, formatExpectedLifeKm } from '../policies/expected-life-labels';

interface RowActions {
  onEdit: (row: PartTypeView) => void;
  onDeactivate: (row: PartTypeView) => Promise<void>;
  onReactivate: (row: PartTypeView) => Promise<void>;
}

/** Each column's `key` is its sort field in `partTypeListQuerySchema`; the actions column is left out without `service.manage`. */
export function buildPartTypeColumns({
  list,
  actions,
}: {
  list: Pick<ListQueryControls<PartTypeListQuery>, 'sortOrderFor'>;
  actions?: RowActions;
}): TableColumnsType<PartTypeView> {
  const columns: TableColumnsType<PartTypeView> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      sortOrder: list.sortOrderFor('name'),
      render: (name: string, row) => <Link to={partTypePath(row.id)}>{name}</Link>,
    },
    {
      title: 'Expected life (km)',
      dataIndex: 'expectedLifeKm',
      key: 'expectedLifeKm',
      sorter: true,
      sortOrder: list.sortOrderFor('expectedLifeKm'),
      render: formatExpectedLifeKm,
    },
    {
      title: 'Expected life (days)',
      dataIndex: 'expectedLifeDays',
      key: 'expectedLifeDays',
      sorter: true,
      sortOrder: list.sortOrderFor('expectedLifeDays'),
      render: formatExpectedLifeDays,
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
  ];
  if (actions) columns.push({ title: '', key: 'actions', render: (_, row) => <CatalogueRowActions row={row} {...actions} /> });
  return columns;
}
